<template>
    <div class="container">
        <div class="row">
            <div class="col-sm 4 col-12 bm-3">
                <div class="card">
                    <div class="card-header bg-info text-white">Agrega un rol</div>
                    <div class="card-body">
                        <form action="" @submit.prevent="storeRole">
                            <div class="form-group">
                                <label for="name">Nombre: </label>
                                <input required type="text" class="form-control" placeholder="Nombre del rol" v-model="role.name">
                            </div>
                            <input class="btn btn-success" type="submit" value="Guardar">
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-sm-8 col-12">
                <div class="card">
                    <div class="card-header text-white bg-primary">Roles de usuario</div>
                    <div class="card-body">
                        <table class="table table-stripped text-center" id="zones-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Nombre</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(role, i) in roles" :key="role.id">
                                    <td>{{i+1}}</td>
                                    <td>
                                        <input type="text" required style="border-radius: 3px; border: none; border-bottom: 1px solid gray" v-model="role.name">
                                        <a href="#" class="ml-3 mb-1 btn btn-sm btn-success" @click.prevent="updateRole(role)"><i class="fa fa-save"></i></a>
                                    </td>
                                    <td width="50px"><input type="button" value="✕" class="btn btn-danger btn-sm" @click="deleteRole(role)"></td>
                                </tr>
                                <tr v-if="roles.length == 0">
                                    <td colspan="3" class="text-center">No hay registros</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
function role(){
    return {
        name: "",
        type: "role"
    }
}
export default {
    name: "Roles",
    created(){
        this.fetchRoles();
    },
    data: () => ({
        roles: [],
        role: role()
    }),
    methods: {
        fetchRoles(){
            const url = `${process.env.VUE_APP_API}/admin/types?type=role`;
            this.$http.get(url).then(response => {
                this.roles = response.body.data;
            })
        },
        storeRole(){
            const url = `${process.env.VUE_APP_API}/admin/types`;
            this.$http.post(url, this.role).then(response => {
                this.roles.push(response.body.data);
                this.role = role();
            })
        },
        updateRole(role){
            const url = `${process.env.VUE_APP_API}/admin/types/${role.id}`;
            this.$http.put(url, role).then(response => {
                const index = this.roles.findIndex(rol => rol.id == response.body.data.id);
                this.roles.splice(index, 1, response.body.data);
            }).catch(error => {
                this.$dialogs.alert("El rol tiene usuarios asociados, no puede ser editado", {title: 'Error', size: 'sm'});
            })
        },
        deleteRole(role){
            const url = `${process.env.VUE_APP_API}/admin/types/${role.id}`;
            this.$http.delete(url).then(response => {
                const index = this.roles.findIndex(rol => rol.id == response.body.data.id);
                this.roles.splice(index, 1);
            }).catch(error => {
                this.$dialogs.alert("El rol tiene usuarios asociados, no puede ser borrado", {title: 'Error', size: 'sm'});
            })
        }
    }
}
</script>

<style>

</style>